let scrollPosition = 0;

export default {
  enable() {
    scrollPosition = window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = scrollOffset(scrollPosition);
    document.body.style.width = '100%';
  },
  disable() {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    window.scrollTo({left: 0, top: scrollPosition, behavior: 'instant'});
  },
};

function scrollOffset(scroll) {
  return (adminWPBarHeight() + stickyHeaderBannerHeight()) - scroll + 'px';
}

function stickyHeaderBannerHeight() {
  return document.querySelector('header.banner')?.clientHeight ?? 0;
}

function adminWPBarHeight() {
  return document.querySelector('#wpadminbar')?.clientHeight ?? 0;
}
